<template>
  <div>
    <menubar />
    <div class="container">
      <div id="title" class="d-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <img src="/img/05_slash.svg" />
          <p class="h1">通知詳細</p>
        </div>
      </div>

      <div class="notification">
      
        <div class="table_style bottom-border">
          <div class="table_cell_left text-right text-black">
            <label for="notification_title_input">タイトル</label>
          </div>
          <div class="table_cell_right fw-bolder">
            {{ message.title }}
          </div>
        </div>

        <div class="table_style bottom-border">
          <div class="table_cell_left text-right text-black">
            <label for="">通知日時</label>
          </div>
          <div class="table_cell_right">
            <span :class="message.is_draft == 0 && new Date(message.scheduled_at) > new Date() ? 'text-red' : ''"> {{new Date(message.scheduled_at_ymdhi).toLocaleString('ja-JP',{'year': 'numeric', 'month' :'numeric','day': 'numeric', 'hour' : 'numeric', 'minute' : 'numeric'}) }}</span>
            <span :class="message.is_draft == 0 && new Date(message.scheduled_at) > new Date() ? 'text-red' : ''"> 
              {{ message.is_draft ==1 ? ' (作成中)' : new Date(message.scheduled_at) >= new Date() ? " (予約中)" : " (通知済)" }}
            </span>
          </div>
        </div>

        <div class="table_style bottom-border">
          <div class="table_cell_left text-right text-black">
            <label for="">重要アイコン</label>
          </div>
          <div class="table_cell_right">
            <span v-if="message.is_important == 1">表示する</span>
            <span v-else>表示しない</span>
          </div>
        </div>

        <div class="table_style bottom-border">
          <div class="table_cell_left text-right text-black">
            <label for="notification_content_textarea">内容</label>
          </div>
          <div class="table_cell_right cell-content">
            {{ message.text }}
          </div>
        </div>
        <div class="table_style modal-btn d-flex justify-content-evenly">
          <input type="button" class="btn btn-red btn-cans" value="閉じる" @click="redirectIndex" />
          <input type="submit" class="btn btn-purple btn-add" value="編集する" v-on:click="redirectEdit(message.id)" />
        </div>
      </div>
    </div>
  <footerComponent />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import modal from '@/Pages/Components/modal.vue';
import menubar from '@/Pages/JVTA/menu_jvta.vue';
import footerComponent from "@/Pages/Components/footer.vue";

export default defineComponent({
  components: {
    menubar,
    modal,
    footerComponent
  },
  props: {message: Object},
  methods: {
    redirectIndex: function () {
      location.href = route('messages.index');
    },
    redirectEdit: function (id) {
      location.href = route('messages.edit', {id: id});
    },
  },
});
</script>

<style lang="scss" scoped>
// タイトル部分「用語集一覧」のcss
.container {
  #title {
    margin: 3rem 0;
    img {
      width: 3rem;
      height: 3rem;
    }
    p {
      color: #333333;
    }
  }
  .title-btn {
    margin: 3rem 0;
    #title {
      margin: 0;
      img {
        width: 3rem;
        height: 3rem;
      }
      p {
        color: #666666;
      }
    }
  }
}

.notification {
  width: 100%;
  margin: auto;
  border: 1px solid #B1B0B0;
  border-radius: 10px;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 13px;
  color: #666666;
  background-color: #ffffff;
  /* font-weight: normal; */
  /*　（全角+半角）の文字で改行しないように */
  white-space: nowrap;
}
.table_style {
  width: 100%;
  padding: 15px 0px;
  display: table;
}
.table_cell_left {
  border-right: 1px solid #B1B0B0;
  display: table-cell;
  vertical-align: middle;
  padding-right: 1rem;
  font-size: 1rem;
}
.table_cell_right {
  display: table-cell;
  vertical-align: middle;
  padding-left: 1rem;
  font-size: 1rem;
}
.text-right {
  width: 115px;
  text-align: right;
}
.text-left {
  width: 0px;
  text-align: left;
}
.left-padding {
  padding-left: 15px;
}
.bottom-border {
  border-bottom: 1px dotted #B1B0B0;
}
.username {
  padding-top: 10px;
  height: 40px;
}

#title {
  margin: 3rem 0;
}
#title img {
  width: 3rem;
  height: 3rem;
}
#title p {
  color: #666666;
}

.container {
  min-height: 80vh;
}
.table {
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

#notification_title_input {
  width: 100%;
}
#notification_content_textarea {
  width: 100%;
}
.reserve_time_input {
  margin-left: 3rem;
}
.btn-and-btn {
  text-align: center;
}
.text-red {
  color: red;
}
.cell-content {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>